import type { MaybeUndef } from 'types/UtilityTypes';

import type { DraftReplyMode } from '../mailclient/interface';

/** Must match drumkit quickQuoteDraftBodyEncodingBase64. */
export const QUICK_QUOTE_DRAFT_BODY_ENCODING_BASE64 = 'base64';

export interface QuickQuoteReplyWirePayload {
  threadItemId: string;
  draftBody: string;
  replyMode: DraftReplyMode;
  to?: string[];
  cc?: string[];
  bcc?: string[];
  draftBodyEncoding?: string;
}

/** TQL customer APIs sit behind a WAF that blocks raw HTML in JSON (OWASP 941320). */
export function shouldEncodeQuickQuoteDraftBodyForApi(
  apiBaseUrl: MaybeUndef<string>
): boolean {
  if (!apiBaseUrl) {
    return false;
  }
  try {
    const url = new URL(apiBaseUrl, 'https://placeholder.invalid');
    const host = url.hostname.toLowerCase();
    return host === 'tqlapp.com' || host.endsWith('.tqlapp.com');
  } catch {
    return false;
  }
}

/** UTF-8 safe base64 for browser + Jest (jsdom has btoa but not TextEncoder). */
export function encodeUtf8ToBase64(text: string): string {
  const binary = encodeURIComponent(text).replace(
    /%([0-9A-F]{2})/gi,
    (_, hex) => String.fromCharCode(parseInt(hex, 16))
  );
  return btoa(binary);
}

export function buildQuickQuoteReplyWirePayload(
  fields: QuickQuoteReplyWirePayload,
  apiBaseUrl: MaybeUndef<string>
): QuickQuoteReplyWirePayload {
  if (!shouldEncodeQuickQuoteDraftBodyForApi(apiBaseUrl)) {
    return fields;
  }

  const payload: QuickQuoteReplyWirePayload = {
    ...fields,
    draftBody: encodeUtf8ToBase64(fields.draftBody),
    draftBodyEncoding: QUICK_QUOTE_DRAFT_BODY_ENCODING_BASE64,
  };
  return payload;
}
